import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { pageUp, pageDown, currentPage, set_ep3_lastVisitFrame } from '../../../Redux/Slices/generalSlice';
import { setLanguageEnglish, setLanguageUrdu, currentLanguage } from '../../../Redux/Slices/languageSlice';
import './F65.css';
import backIcon2 from '../../../Assests/backIcon2.svg'

function Frame65() {
    let dispatch = useDispatch();
    let pageNo = useSelector(currentPage);
    let language = useSelector(currentLanguage);

    useEffect(() => {

    }, [])

    
        return (
            <div className="F65_imageAnimate">
                <img onClick={() => { dispatch(pageDown()) }} className='backButton' src={backIcon2} alt="React Logo" height={30} />
                <div className="F65_entryBox">
                    <div className="F65_paragraph">
                        {language === 'english' ?
                            <p className="F65_paragraphEnglish">The other senior schoolgirl tells Saira that if it was not forbidden, she wishes she could take shower during menstruation. Saira is surprised to hear this but she’s seeing this as an opportunity to address widespread misconceptions concerning menstruation</p>
                            :
                            <p className="F65_paragraphUrdu"> ایک اور لڑکی سائرا سے یہ کہتی ہے کہ اگر ماہواری کے دوران نہانا منع نہ ہوتا تو وہ ضرور نہاتی۔ سائرا کو یہ جان کر بہت تعجب ہوا کہ اس غلط فہمی پر بھی لڑکیاں کیسے یقین کرتی ہیں۔</p>
                        }
                    </div>

                    <div className="F65_timeline">
                        <div className='F65_timelineBar'>
                            <div className='F65_timelineFill'></div>
                            <span className='F65_timelineText'>12/14</span>
                        </div>
                    </div>

                    <div className="F65_nextFrames">
                        <div className="F65_nextFrame1"></div>
                        <div className="F65_nextFrame2"></div>
                        <div className="F65_nextFrame3"></div>
                    </div>

                    <div className='F65_buttonDiv'>
                        <button onClick={() => { dispatch(pageUp()); dispatch(set_ep3_lastVisitFrame(12)) }} className='F65_button'>
                            {language === 'english' ? 'Continue' : 'آگے  جائیں'}
                        </button>
                    </div>

                </div>
            </div>
        )
    
}

export default Frame65;